import { API } from '.';

class ContactService {
    async approveContact(contactId) {
        const response = await API.post('/api/approve-contact', {
            data: {
                contact: contactId,
            },
        });
        return response.data.data;
    }

    async updateContact(contact) {
        const response = await API.put(`/api/contacts/${contact.id}`, {
            data: contact,
        });

        return response.data.data;
    }

    async sendBulkMessageByStatus(
        companySlug,
        message,
        messageType,
        candidacyStatuses,
        subject,
        jobId,
    ) {
        try {
            const response = await API.post('/api/contacts/bulk-message', {
                data: {
                    companySlug,
                    message,
                    candidacyStatuses,
                    type: messageType,
                    ...(subject && { subject }),
                    ...(jobId && { jobId }),
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export default ContactService;
